// The Accelerator's Actions page (/accelerator/actions; no board draws it, so it takes the home's
// card, Accelerator.dc.html's "This month's actions", and its words are listed for Adam). This
// month's actions, each ticked as they go and with the member's note on how it's going, which Adam
// reads before the session. The past months are 1 line pointing to their accountability log, which says
// how each went, in the same words as everywhere else (the Accelerator critique's member 7, 20 Oct); the
// button beside the heading opens it too. While staff view as a member nothing can be ticked or noted.
import { Link } from '../../lib/router.jsx'
import { useNow } from '../../lib/clock.js'
import { useViewingAs } from '../../lib/viewAs.jsx'
import { useProductData } from '../../product/ProductData.jsx'
import { myIntake } from '../../product/model.js'
import { ActionsCard } from '../../products/accelerator/Actions.jsx'
import { LoadFailed, Loading, useAccelerator } from '../../products/accelerator/Page.jsx'
import { COPY } from '../../products/accelerator/copy.js'
import { cyclesView, dueLine, standingFor } from '../../products/accelerator/model.js'

export default function MastermindActions({ product }) {
  const { data } = useProductData()
  const viewingAs = useViewingAs()
  const nowMs = useNow()
  const mm = useAccelerator(product)
  if (mm.status === 'loading') return <Loading />
  if (mm.status === 'error' || !mm.data) return <LoadFailed onRetry={mm.reload} />

  const p = data.product || product
  const standing = standingFor(mm.data.standing, p.id)
  const group = standing?.cohort_name || myIntake(data)?.name || null
  const view = cyclesView(mm.data.cycles, mm.data.actions, data.sessions)

  return (
    <div className="acc-page">
      <section className="pl-head pl-head--row">
        <div>
          {group && <div className="pl-eyebrow">{group}</div>}
          <h1 className="pl-h1">{COPY.actionsH1}</h1>
        </div>
        <Link className="acc-btn-line" to={`${p.path}/accountability-log`}>{COPY.viewLog}</Link>
      </section>
      <ActionsCard month={view.open} viewingAs={viewingAs} patch={mm.patch} notes due={dueLine(data.sessions, nowMs)} />
      {view.past.length > 0 && (
        <section className="acc-past-list" aria-labelledby="acc-past-h">
          <h2 className="pl-h2" id="acc-past-h">{COPY.pastMonths}</h2>
          <p className="acc-text acc-past-line">
            {COPY.pastInLog} <Link className="acc-text-link" to={`${p.path}/accountability-log`}>{COPY.pastInLogLink}</Link>.
          </p>
        </section>
      )}
    </div>
  )
}
